<template>


  <div>
    <div class="sub-header">
      <div class="width-wrapper relative">
        <div class="page-title">Аптеки</div>

        <div class="header__save" v-if="$store.state.user.role == ''">
          <a href="#/pharmacies/new/" class="button">Добавить аптеку</a>
        </div>
      </div>
    </div>
    <div class="width-wrapper">

      <div class="filter">
        <div style="display: inline-block; vertical-align: middle; width: 300px; padding-top: 30px">
          <material-input parentClass="" label="ID или Название"
                          @inputStr="inputStr"
                          v-bind:valueStr="search"
          ></material-input>
        </div>
      </div>

      <div class="pharmacies-list">
        <div class="pharmacy-list-item"
             :class="pharmacy.is_template?' pharmacy-list-item--template':''"
             v-for="pharmacy in pharmaciesList"
             @click="$router.push('/pharmacies/'+pharmacy.id+'/')">

            <div class="pharmacy-list-item__has-changes" v-if="pharmacy.has_changes" title="Есть изменения"></div>
          <div class="pharmacy-list-item__picture">
            <svg :view-box.camel="pharmacy.viewbox">
              <g>
                <path :d="pharmacy.contour"></path>
                <path v-for="(partition, index) in pharmacy.partitions" :d="partition.str"></path>
              </g>
            </svg>
          </div>
          <div class="pharmacy-list-item__description">
            <div class="pharmacy-list-item__name">{{pharmacy.title}}</div>
            <div class="pharmacy-list-item__cats" v-if="!pharmacy.is_template">
              Кат.: <span class="pharmacy-list-item__cats-item" v-for="category in pharmacy.categories">{{category.title}}</span>
            </div>
            <div class="pharmacy-list-item__cats" v-if="pharmacy.is_template">
              Эталонная аптека
            </div>
            <div class="pharmacy-list-item__facing-info"></div>
          </div>
        </div>
      </div>
    </div>

    <router-view></router-view>
  </div>
</template>


<script>
//  import axios from 'axios';
  import Vue from 'vue';
  import lodash from 'lodash';
  import VueLodash from 'vue-lodash/dist/vue-lodash.min';
  import axios from 'axios';

  Vue.use(VueLodash, lodash);
  export default {
    name: 'pharmacies',
    data() {
      return {
        pharmaciesList: [],
        search: '',
      };
    },
    created() {
      this.load('');
    },
    watch: {
      search(val) {
        this.load(val);
      },
    },
    methods: {
      inputStr: Vue._.debounce(function mutated(input) { this.search = input; }, 500),
      load(str) {
        const that = this;
        axios.get(`/api/v2/pharmacies/?search=${str}`).then((response) => {
          // console.log(response.data);
          that.makeList(response.data);
        });
      },
      makeList(response) {
        this.pharmaciesList = [];

        if (response.length > 0) {
          response.forEach((pharmacy) => {
            const pharmacyO = Object.assign({}, pharmacy);

            let maxX = 0;
            let maxY = 0;
            // console.log(pharmacy.contour);
            // const contour = JSON.parse(pharmacy.contour);
            // console.log(contour);
            if (pharmacy.contour !== null) {
              const points = pharmacy.contour.map((stat, i) => {
                if (stat.x > maxX) { maxX = stat.x; }
                if (stat.y > maxY) { maxY = stat.y; }
                return `${i > 0 ? 'L' : ''} ${stat.x},${stat.y}`;
              }).join(' ');
              pharmacyO.contour = `M ${points} Z`;

              pharmacyO.maxX = maxX;
              pharmacyO.maxY = maxY;
              pharmacyO.viewbox = `0, 0, ${maxX}, ${maxY}`;
            }

            // let walls = JSON.parse(pharmacy.walls);
            if (pharmacy.walls !== null) {
              // eslint-disable-next-line no-const-assign
              const walls = pharmacy.walls.map((line) => {
                // eslint-disable-next-line no-param-reassign,arrow-body-style
                line.str = line.map((point, i) => {
                  return `${i > 0 ? 'L' : ''} ${point.x},${point.y}`;
                }).join(' ');
                // eslint-disable-next-line no-param-reassign
                line.str = `M ${line.str}`;
                return line;
              });

              pharmacyO.partitions = walls;
            }
            this.pharmaciesList.push(pharmacyO);
          });
        }
      },
    },
  };

</script>


<style lang="less">
  svg{
    width: 100%;
    height: auto;
    max-height: 100%;
  }

  path {
    stroke: #D3D3D4;
    stroke-width: 20px;
    fill: transparent;
  }

  .pharmacies-list {
    font-size: 0;
    margin: 40px -8px;
  }

  .pharmacy-list-item{
    display: inline-block;
    width:334px;
    height:346px;
    padding: 20px 20px 10px;
    box-sizing: border-box;
    background: #FFFFFF;
    margin: 0 8px 8px;
    cursor: pointer;
    vertical-align: top;
    position: relative;

      &__has-changes {
          border-radius: 50%;
          width: 10px;
          height: 10px;
          background: lightcoral;
          position: absolute;
          right: 10px;
          top: 10px;
      }

    &--template {
      background: lightyellow;
    }

    &__picture{
      height: 175px;
      margin-bottom: 15px;
    }

    &__description{
      height: 70px;
      position: relative;
    }

    &__name{
      font-size: 24px;
      color: #262626;

    }

    &__cats{
      font-size: 12px;
      color: #000000;
      line-height: 14px;

      &-item{
        margin-right: 3px;
        &::after{
          display: inline-block;
          content: ", ";
        }

        &:last-child::after{
          display: none;
        }
      }
    }

    &__facing-info{
      position: absolute;
      bottom:0;
      left: 0;
      font-size: 14px;
      color: #768791;
      line-height: 17px;
    }
  }


</style>


// WEBPACK FOOTER //
// Pharmacies.vue?930a219a